<input #autoInput nbInput fullWidth type="text" (input)="onChange()" [placeholder]="placeholder"
  [nbAutocomplete]="auto" [disabled]="(options$ | async).length === 0 ? true: false" [ngModel]="inputModel" (ngModelChange)="inputModelChange.emit($event)" />

<nb-autocomplete #auto (selectedChange)="onSelectionChange($event)" [handleDisplayFn]="viewHandle">

  <nb-option *ngFor="let option of filteredOptions$ | async" [value]="option.value">
    {{ option.text }}
  </nb-option>

</nb-autocomplete>